import HotelCardLabels from './HotelCardLabels';

export default HotelCardLabels;
